module.exports = __webpack_public_path__ + "static/img/service.7b4d86cc.png";